import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { Ticket, ArrowUpRight } from 'lucide-react';


const MobileTicketsBar = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show bar after a small delay to let hero load
    const timer = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(timer);
  }, []);

  const ticketUrl = '/#tickets';
  const label = t('nav.tickets');

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 180, damping: 22, mass: 0.5 }}
          className="fixed bottom-0 inset-x-0 z-40 lg:hidden"
          data-testid="mobile-tickets-bar"
        >
          {/* Backdrop with gradient mask */}
          <div
            aria-hidden="true"
            className="absolute inset-x-0 -top-6 h-6 bg-gradient-to-t from-[#060606] to-transparent pointer-events-none"
          />

          <div className="relative bg-[#060606]/95 backdrop-blur-xl border-t border-white/10 px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
            <a
              href={ticketUrl}
              className="block"
              data-testid="mobile-tickets-bar-button"
            >
              <motion.div
                whileTap={{ scale: 0.97 }}
                whileHover={{ scale: 1.02 }}
                className="relative overflow-hidden w-full h-14 rounded-full bg-gradient-to-r from-[#C9A84C] via-[#E2C56A] to-[#C9A84C] bg-[length:200%_100%] animate-[gradient-x_4s_ease_infinite] text-[#060606] font-display uppercase tracking-[0.25em] text-sm flex items-center justify-center gap-3 shadow-[0_10px_30px_-10px_rgba(201,168,76,0.6)]"
              >
                {/* Shimmer effect */}
                <span
                  aria-hidden="true"
                  className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent animate-[shimmer_2.5s_infinite]"
                />

                <motion.span
                  animate={{ rotate: [0, -8, 8, 0] }}
                  transition={{ duration: 2.4, repeat: Infinity, ease: 'easeInOut' }}
                >
                  <Ticket className="w-5 h-5" strokeWidth={2.5} />
                </motion.span>

                <span className="relative truncate max-w-[calc(100vw-140px)]">
                  {label}
                </span>

                <motion.span
                  animate={{ x: [0, 3, 0] }}
                  transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
                  className="flex-shrink-0"
                >
                  <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
                </motion.span>
              </motion.div>
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileTicketsBar;
